import Vue from "vue";
import { i18n } from "@/locale/i18n";
import vuetify from "./plugins/vuetify";
import BootstrapVue from "bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import IdleVue from "idle-vue";
// import "./registerServiceWorker";

// include bootstrap
import "bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

// include flag-icon-css
import "flag-icon-css/css/flag-icon.css";

// include nicescroll
import "jquery.nicescroll";

// include sticky-kit
import "sticky-kit/dist/sticky-kit";

// include font-awesome
import "@fortawesome/fontawesome-free/css/all.css";

// include custom style
import "./assets/css/style.css";
import "./assets/css/custom.css";

Vue.config.productionTip = false;

Vue.prototype.$http = axios;

const eventsHub = new Vue();

Vue.use(BootstrapVue);

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 900000
});

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
